import type { MatterMemberRead } from '@/matter/components/manage-members/schemas'

export const kUnavailableMemberDisplayName = 'Unavailable user'
const kUnavailableMemberInitials = 'U'

/**
 * Extracts 1-2 character initials from a name or email string.
 * - Single word: first character (e.g., "Alice" → "A")
 * - Multiple words: first + last initials (e.g., "Alice Smith" → "AS")
 */
export function getInitialsFromString(raw: string): string {
  const words = raw.trim().split(/\s+/)
  if (words.length === 0 || words[0] === '') return ''
  if (words.length === 1) return words[0].charAt(0).toUpperCase()
  return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase()
}

export function getMemberInitials(member: MatterMemberRead): string {
  const displaySource = member.display_name ?? member.email
  if (!displaySource) return kUnavailableMemberInitials
  return getInitialsFromString(displaySource)
}

export function getMemberDisplayName(member: MatterMemberRead): string {
  return member.display_name ?? member.email ?? kUnavailableMemberDisplayName
}
